export default __webpack_public_path__ + "static/logos-8c5061773bdcea8c7040cbdd73b0b1cd.png";